export interface WirelessNetwork {
  startDate: string;
  affectedServices: string;
  affectedRegions: string;
  affectedCounties: string;
}

export interface HDWeatherandTraffic {
  startDate: string;
  Message: string;
}

export class Tss {
  constructor(
    public data?: any,
  ) { }


  /**
  * @function form returns the translations for the dialog boxs title, note, report and columns on condition.
  * @returns {Object}
  **/
  get form(): Object {
    if (this.data['type']['name'] === 'Wireless Network') {
      return {
        title: 'tss-dialog.labels.wirelessnetwork',
        note: 'tss-dialog.labels.wirelessnetwork-note',
        report: 'tss-dialog.labels.wirelessnetwork-no-report',
        columns: ['startDate', 'affectedServices', 'affectedRegions', 'affectedCounties']
      };
    } else if (this.data['type']['name'] === 'HDWeather & Traffic') {
      return {
        title: `tss-dialog.labels.${this.data['type']['applicationName']}`,
        note: `tss-dialog.labels.${this.data['type']['applicationName']}-note`,
        report: `tss-dialog.labels.${this.data['type']['applicationName']}-no-report`,
        columns: ['outageStartDateString', 'message']
      };
    }
    return {
      title: `tss-dialog.labels.${this.data['type']['applicationName']}`,
      note: `tss-dialog.labels.${this.data['type']['applicationName']}-note`,
      report: `tss-dialog.labels.${this.data['type']['applicationName']}-no-report`,
      columns: ['message']
    };
  }

  /**
  * @function boolean returns true if records exist
  * @returns boolean
  **/
  get isReported(): boolean {
    return this.data['type']['status'] === 'Normal' ? true : false;
  }

  /**
* @function recordsData returns parsed records list
* @returns  WirelessNetwork[] | HDWeatherandTraffic[]
**/
  get recordsData(): WirelessNetwork[] | HDWeatherandTraffic[] {
    const outageRecords: WirelessNetwork[] | HDWeatherandTraffic[] = this.data['type']['cannedMessages'].length !== 0 ? this.data['type']['cannedMessages'] : [{message: this.data['type']['comment']}] ;
    return outageRecords;
  }
}
